import { render } from "./WorkflowSettingsTemplateCards.vue?vue&type=template&id=1912724e&scoped=true"
import script from "./WorkflowSettingsTemplateCards.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsTemplateCards.vue?vue&type=script&lang=js"

import "./WorkflowSettingsTemplateCards.vue?vue&type=style&index=0&id=1912724e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1912724e"]])

export default __exports__